module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/20-011a764320b4b68f3212a09c02a9bf77.jpg";